import React from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Phone } from "lucide-react";
import RenovatieFAQ from "../components/faqs/RenovatieFAQ";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";

function ElektraRenovatie() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Elektra renovatie Arnhem - elektricienarnhem026.nl"
        description="Upgrade uw elektrische installatie in Arnhem naar de moderne standaard. Onze experts zorgen voor een veilige en toekomstbestendige oplossing."
        image="/images/banner.png"
      />
      <Header />
      <HeroSection
        title="Complete elektra renovatie in Arnhem"
        description="Upgrade uw elektrische installatie in Arnhem naar de moderne standaard. Onze experts zorgen voor een veilige en toekomstbestendige oplossing."
        imageSrc="/images/mark.png"
      />
      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Hoe weet je of je elektra in je woning in Arnhem moet vernieuwen?
            </h2>
            <p>
              Is je woning in Arnhem verouderd en voldoet de elektra niet meer
              aan de huidige eisen? Het kan zijn dat je meterkast, bedrading, of
              stopcontacten vervangen moeten worden. Bij een renovatie van je
              woning, keuken of badkamer in Arnhem is het belangrijk om te
              controleren of de elektrische installatie veilig en up-to-date is.
              Wij bieden een volledige renovatie van je elektra, zodat alles
              veilig en volgens de laatste normen werkt.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="Oude stoppenkast"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/oud-groepenkast.png"
              />
            </div>
          </div>
        </div>

        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Renovatie van elektra in je hele woning in Arnhem
            </h2>
            <p>
              Bij een volledige renovatie van je woning in Arnhem is het
              belangrijk om de elektra grondig aan te pakken. Dit kan variëren
              van het vernieuwen van de groepenkast, het toevoegen van
              stopcontacten en schakelaars, tot het installeren van nieuwe
              apparaten en verlichting. Onze specialisten zorgen ervoor dat je
              elektra veilig, efficiënt en volgens de laatste normen wordt
              vernieuwd, zodat je woning voldoet aan de nieuwste eisen en je
              energieverbruik optimaal is.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="Slim stroom handelen met thuisbatterij"
                loading="lazy"
                width="1028"
                height="1032"
                className="rounded-lg w-full h-auto"
                decoding="async"
                data-nimg="1"
                src="/images/renovatie-thumb.jpg"
                srcSet="/images/renovatie-thumb.jpg"
                style={{ color: "transparent" }}
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Groepenkast vernieuwen?
            </h2>
            <p>
              Heb je een nieuwbouwwoning, maar is je groepenkast nog niet
              aangesloten? Dan is het belangrijk om snel een betrouwbare en
              veilige installatie te laten uitvoeren. Of je nu een
              inductiekookplaat, elektrische verwarming of andere zware
              apparatuur hebt, wij zorgen ervoor dat je groepenkast volgens de
              nieuwste normen wordt aangesloten.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>
              <img
                alt="Kookgroep installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/ABB-220x280-1F.webp"
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center">
          <div className="relative mx-auto bg-amber-100 px-5 py-3 w-full rounded-xl max-w-[1088px] lg:mb-12 lg:w-[calc(100%-2rem)] grid grid-cols-[1fr] gap-10 md:gap-12">
            <div>
              <h2 className="font-normal text-black text-md">
                Wij kunnen zorgdragen voor de verplaatsing van de groepenkast,
                zodat het nutsbedrijf de nieuwe aansluiting efficiënt en zonder
                complicaties kan realiseren.
              </h2>
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <RenovatieFAQ />

      <ServiceHighlights />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#FFD100] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Offerte aanvragen
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default ElektraRenovatie;
